import { useCallback, useRef, useState } from 'react'
import type { CmsPage as CmsContent } from '../../../cms/types'
import { fetchHomePageBySlug } from '../shopRuntimeApi'

const resolveHomePageErrorMessage = (error: unknown) =>
  error instanceof Error && error.message.includes('404')
    ? 'Homepage non trovata. Crea o pubblica la pagina.'
    : 'Errore caricamento homepage'

export const useHomePageContent = () => {
  const [homePageData, setHomePageData] = useState<CmsContent | null>(null)
  const [homePageLoading, setHomePageLoading] = useState(false)
  const [homePageError, setHomePageError] = useState('')
  const requestIdRef = useRef(0)

  const loadHomePage = useCallback(async (slugValue: string) => {
    const requestId = requestIdRef.current + 1
    requestIdRef.current = requestId
    setHomePageLoading(true)
    setHomePageError('')
    try {
      const page = await fetchHomePageBySlug(slugValue)
      if (requestIdRef.current !== requestId) return
      setHomePageData(page)
      if (typeof document !== 'undefined') {
        document.title = page.metaTitle || page.title || 'Homepage'
      }
    } catch (error) {
      if (requestIdRef.current !== requestId) return
      setHomePageError(resolveHomePageErrorMessage(error))
      setHomePageData(null)
    } finally {
      if (requestIdRef.current === requestId) {
        setHomePageLoading(false)
      }
    }
  }, [])

  return {
    homePageData,
    homePageLoading,
    homePageError,
    loadHomePage,
  }
}
